import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Popup } from 'semantic-ui-react';
import { connect } from 'react-redux';
import history from '../../history';
import { setDraftStake, updateUserBalanceAction } from '../rootReducer';
import { STATUS } from '../../utils/status';
import { calculateWin } from '../CreateStake/OddsSlider';
import { updateStake, deleteStake } from '../../firebase';
import ViewStake from './ViewStake';
import CreateStake from '../CreateStake/CreateStake';

// import StakeButton from './StakeButton'

class IssuedStake extends Component {
  static propTypes = {
    stake: PropTypes.object.isRequired
  };

  state = {
    isLoading: false,
    insufficientBalance: false
  };

  async updateStake(stake, id, balanceChange) {
    this.setState({ isLoading: true });
    try {
      updateStake(stake, id)
        .then(() => {
          if (balanceChange) {
            this.props.updateUserBalanceAction(balanceChange);
          }
        });

      history.push('/');
    }
    catch (err) {
      console.error('Error updating stake', err);
    }
  }

  revokeStake = () => {
    console.log('not yet implemented');
  };

  declineStake = () => {
    const stake = { ...this.props.stake };

    if (stake.status === STATUS.Reissued) {
      // Decline the edit request, delete the edited stake
      const ogStake = this.props.allStakes.find(x => x.id === stake.originalStakeId);
      ogStake.isBeingEdited = false;      
      deleteStake(stake.id);
      this.updateStake(ogStake, ogStake.id);
      return;
    }
    
    stake.status = STATUS.Declined;
    stake.playerDeclined = stake.isMyStake ? stake.stakerId : stake.stakee;
    this.updateStake(stake, this.props.stake.id);
  };

  acceptStake = () => {
    const stake = { ...this.props.stake };

    let liability = calculateWin(stake.amount, stake.odds);

    if (stake.status === STATUS.Reissued) {
      const ogStake = this.props.allStakes.find(x => x.id === stake.originalStakeId);
      
      // Return my original stake amount
      const oldLiability = ogStake.amount;
      liability -= oldLiability;

      if (liability > this.props.availableBalance) {
        this.setState({insufficientBalance: true});
        return;
      }
      // Return origial stakee's liability
      const oldStakeeLiability = calculateWin(ogStake.amount, ogStake.odds);

      let newLiabilityForStakee = oldStakeeLiability - stake.amount;
      this.props.updateUserBalanceAction(newLiabilityForStakee, ogStake.stakee);
      console.log('Update og stakee balance', newLiabilityForStakee)
      
      deleteStake(ogStake);
      // Delete stake.originalStakeId ?? 
    } 
    else if (liability > this.props.availableBalance) {
      this.setState({insufficientBalance: true});
      return;
    }

    stake.status = STATUS.Live;
    this.updateStake(stake, this.props.stake.id, -liability);
  };

  render() {
    const { isLoading } = this.state;
    const { stake } = this.props;

    return (
      <ViewStake
        stake={stake}
        actions={
          stake.isMyStake ? (
            <div className="equal-width">
              {/* <Button fluid color="grey" size="large" loading={isLoading} disabled={isLoading} onClick={this.revokeStake}>
                Revoke
              </Button>             */}
            </div>
          ) : (
            <div>
              <div className="equal-width">
                {/* <StakeButton negative onClick={this.declineStake} text="Decline" /> */}
                <Button
                  fluid
                  negative
                  size="large"
                  loading={isLoading}
                  disabled={isLoading}
                  onClick={this.declineStake}
                >
                  Decline
                </Button>
                <Popup 
                  content={'Insufficient balance to accept this stake'}
                  trigger={
                    <Button
                      fluid
                      primary
                      size="large"
                      loading={isLoading}
                      disabled={isLoading}
                      onClick={this.acceptStake}
                    >
                      Accept
                    </Button>
                  }
                  on='click'
                  open={this.state.isOpen}
                  inverted
                />
              </div>

              <Modal
                trigger={
                  <Button
                    fluid
                    color="grey"
                    size="large"
                    loading={isLoading}
                    disabled={isLoading}
                  >
                    Edit
                  </Button>
                }
                closeIcon
                dimmer="inverted"
                className="animated slideInUp fadeOut"
                style={{ animationDuration: '0.65s' }}
              >
                <Modal.Content>
                  <CreateStake editStake={stake} />
                </Modal.Content>
              </Modal>
            </div>
          )
        }
      />
    );
  }
}

const mapStateToProps = ({ app }) => ({
  availableBalance: app.availableBalance
});

export default connect(mapStateToProps, { setDraftStake, updateUserBalanceAction })(IssuedStake);



// WEBPACK FOOTER //
// ./src/App/ViewStake/IssuedStake.js